<template>
  <div>
    <p class="cm-mg-p-wzd text-center text-muted">
      3.1 {{ $t('common_words.contact_position_info') }}
    </p>
    <hr />
    <div class="row">
      <div class="col-4">
        <fg-input
          type="text"
          :label="`${$t('common_words.contact_name')}: `"
          v-model="model.contact_names[0]"
          name="common_words.contact_name"
          v-validate="modelValidations.contact_name"
          :error="getError('common_words.contact_name', true)"
          placeholder="Juan Perez"
        ></fg-input>
      </div>
      <div class="col-4">
        <fg-input
          type="text"
          :label="`${$t('common_words.contact_position')}: `"
          v-model="model.contact_positions[0]"
          :placeholder="$t('common_words.contact_position_example')"
          name="common_words.contact_position"
          v-validate="modelValidations.contact_positions"
          :error="getError('common_words.contact_position', true)"
        ></fg-input>
      </div>
      <div class="col-2">
        <fg-input
          type="number"
          :label="`${$t('common_words.phone')}: `"
          v-model.number="model.contact_phones[0]"
          name="common_words.phone"
          v-validate="modelValidations.contact_phone"
          :error="getError('common_words.phone', true)"
          placeholder="3125689741"
        ></fg-input>
      </div>
      <div class="col-1">
        <div class="text-left">
          <label style="color: transparent">{{
            $t('common_words.options')
          }}</label>
          <button
            class="btn btn-secondary custom-shadow-btn"
            @click="handlePlus(0)"
          >
            <em class="fa fa-plus"></em>
          </button>
        </div>
      </div>
      <div class="col-1">
        <div class="text-left">
          <label style="color: transparent">{{
            $t('common_words.options')
          }}</label>
          <button
            class="btn btn-secondary custom-shadow-btn"
            @click="handleMinus(0)"
          >
            <em class="fa fa-minus"></em>
          </button>
        </div>
      </div>
    </div>
    <div class="row" v-for="index in model.nContacts" :key="index">
      <div class="col-4">
        <fg-input
          type="text"
          label=""
          :name="`${$t('common_words.name')} ${index + 1}`"
          v-model="model.contact_names[index]"
          v-validate="modelValidations.contact_name"
          placeholder="Juan Perez"
          :error="
            getError(`${$t('common_words.name')} ${index + 1}`, true, index)
          "
        ></fg-input>
      </div>
      <div class="col-4">
        <fg-input
          type="text"
          label=""
          :name="`'common_words.position' ${index + 1}`"
          v-model="model.contact_positions[index]"
          v-validate="modelValidations.contact_positions"
          :placeholder="$t('common_words.manager')"
          :error="getError('common_words.position', true, index)"
        ></fg-input>
      </div>
      <div class="col-2">
        <fg-input
          type="number"
          label=""
          :name="`${$t('common_words.phone')} ${index + 1}`"
          v-model.number="model.contact_phones[index]"
          v-validate="modelValidations.contact_phone"
          placeholder="3125689741"
          :error="
            getError(`${$t('common_words.phone')} ${index + 1}`, true, index)
          "
        ></fg-input>
      </div>
      <div class="col-1">
        <div class="text-left">
          <button
            class="btn btn-secondary custom-shadow-btn"
            @click="handlePlus(index)"
          >
            <em class="fa fa-plus"></em>
          </button>
        </div>
      </div>
      <div class="col-1">
        <div class="text-left">
          <button
            class="btn btn-secondary custom-shadow-btn"
            @click="handleMinus(index)"
          >
            <em class="fa fa-minus"></em>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import MixinPermissions from 'src/util/mixinPermissions';
import MixinForm from 'src/mixins/forms/mixin-form';
import mixinMasters from 'src/util/mixinMasters';

export default {
  data() {
    return {
      model: {
        nContacts: 0,
        contact_names: [],
        contact_phones: [],
        contact_positions: [],
      },
      modelValidations: {
        contact_name: {
          required: true,
        },
        contact_phone: {
          required: true,
        },
        contact_positions: {
          required: true,
        },
      },
    };
  },
  mixins: [MixinPermissions, MixinForm, mixinMasters],
  methods: {
    validate() {
      this.model.contact_names = this.model.contact_names; //.filter(Boolean);
      this.model.contact_phones = this.model.contact_phones; //.filter(Boolean);
      this.model.contact_positions = this.model.contact_positions; //.filter(Boolean);
      return this.$validator.validateAll().then((res) => {
        this.$emit('on-validated', res, this.model);
        this.$emit('fillSeedbedsForm', 'thirdStep', {
          contact_names: this.model.contact_names,
          contact_phones: this.model.contact_phones,
          contact_positions: this.model.contact_positions,
        });

        return res;
      });
    },

    handleMinus(indexC) {
      if (this.model.contact_names.length > 0) {
        this.model.nContacts--;
        this.model.contact_names = this.model.contact_names.filter(
          (el, index) => index !== indexC
        );
        this.model.contact_phones = this.model.contact_phones.filter(
          (el, index) => index !== indexC
        );
        this.model.contact_positions = this.model.contact_positions.filter(
          (el, index) => index !== indexC
        );
      }
    },
    handlePlus(indexC) {
      this.model.nContacts++;
      this.model.contact_names = this.model.contact_names
        .slice(0, indexC + 1)
        .concat(null)
        .concat(
          this.model.contact_names.slice(
            indexC + 1,
            this.model.contact_names.length
          )
        );

      this.model.contact_phones = this.model.contact_phones
        .slice(0, indexC + 1)
        .concat(null)
        .concat(
          this.model.contact_phones.slice(
            indexC + 1,
            this.model.contact_phones.length
          )
        );

      this.model.contact_positions = this.model.contact_positions
        .slice(0, indexC + 1)
        .concat(null)
        .concat(
          this.model.contact_positions.slice(
            indexC + 1,
            this.model.contact_positions.length
          )
        );
    },
  },

  created() {
    this.showHideLoading();
  },

  mounted() {
    let editForm = {};
    if (this.isUpdate() && sessionStorage.getItem('editForm')) {
      editForm = JSON.parse(sessionStorage.getItem('editForm'));
      editForm.business_contacts.forEach((element) => {
        this.model.contact_names.push(element.name);
        this.model.contact_positions.push(element.position);
        this.model.contact_phones.push(element.phone);
      });
      this.model.nContacts =
        editForm.business_contacts.length > 0
          ? editForm.business_contacts.length - 1
          : 0;
    }
  },
};
</script>
<style></style>
